import { render, staticRenderFns } from "./blood-oxygen-cell.vue?vue&type=template&id=3c8fab32&scoped=true"
import script from "./blood-oxygen-cell.vue?vue&type=script&lang=js"
export * from "./blood-oxygen-cell.vue?vue&type=script&lang=js"
import style0 from "./blood-oxygen-cell.vue?vue&type=style&index=0&id=3c8fab32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fab32",
  null
  
)

export default component.exports